
/* ============================== src/utils/assignmentApproval.js ============================== */
// path: frontend/src/utils/assignmentApproval.js
/**
 * Справочники согласования назначений. `buildApprovalHint` — заглушка:
 * клиентская проверка «потребуется ли согласование» удалена (PR 2c).
 * Реальное решение принимает сервер (AssignmentApprovalService.
 * requestIfNeeded) и сообщает клиенту через `409` с
 * `details.needsConfirmation`; useTaskSave/ProjectModal.saveHandler
 * показывают confirm и повторяют запрос без version.
 */
export const ASSIGNMENT_TARGET_KINDS = {
  task: { label: "Задача" },
  project: { label: "Проект" },
};

export const ASSIGNMENT_APPROVAL_STATUSES = {
  pending: { label: "Ожидает решения" },
  approved: { label: "Согласовано" },
  rejected: { label: "Отклонено" },
  reassigned: { label: "Переназначено" },
};

export function buildApprovalHint() {
  return null;
}
